<template lang="pug">
  .auth
    .form(v-if="state == 'login'")
      h2 Welcome to MityQuotes!
      .container
        login
        p 
          a(@click="state = 'create'") Create Account
      financing.financing-footer(v-if="this.$root.currentSite == 'MityLite'")
    .form(v-else)
      h2 New Account Information
      .container        
        createAccount
        p
          a(@click="state = 'login'") I already have an account
</template>

<script>
import connect from "../scripts/database.js";
import { Quotes } from "../scripts/quotes.js";

export default {
  name: "Authentication",
  data() {
    return {
      state: "login"
    };
  },
  methods: {},
  created: function() {
    this.$root.currentPage = "Authentication";
  }
};
</script>

<style lang="scss">
@import "../assets/styles/variables.scss";

#app .auth {
  h2 {
    background: $light_gray;
    font-size: 1.3em;
    padding: 1.5em 1em;
  }
  .container {
    padding: 0 24px;

    p {
      font-size: 0.9em;
      padding-bottom: 2em;
      text-align: center;
    }
  }
}
</style>
